import React, { Fragment } from 'react'
import { Skeleton } from 'iuvity-ui-components/dist/skeleton'

export const FormSkeleton: React.FC<{ length: number }> = ({ length = 4 }) => (
	<>
		{[...Array(length)].map((_, index) => (
			<Fragment key={`skeleton-${String(index)}`}>
				<Skeleton width='25%' height='1rem' />
				<br />
				<Skeleton width='100%' height='1rem' />
				<br />
			</Fragment>
		))}
	</>
)
